import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import replace from 'lodash/replace';
import map from 'lodash/map';
import AbnormalitySelectionModal from './AbnormalitySelectionModal';
import AuthorizedComponent from '../../../../components/AuthorizedComponent';
import { ROLES, I18N } from '../../../../constants';
import { formatDateTime } from '../../../../shared/utils/date';
import './AbnormalitiesList.css';

const linkFormatter = (cell, row) => (
    <Link to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${row.abnormalityId}`}>
        {replace(cell, '_', ' ')}
    </Link>
);
const indexFormatter = (cell, row, obj, index) => index + 1;
const dateFormatter = (cell, row, obj, index) => formatDateTime(cell);
const recoveryActionsFormatter = (cell, row) => {
    if (row.recoveryActions && row.recoveryActions.length > 0) {
        return (
            <div>
                {map(row.recoveryActions, rec => (
                    <p key={rec.recoveryActionId}>
                        <Link
                            to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${
                                row.abnormalityId
                            }/recoveryAction/${rec.recoveryActionType}/${rec.recoveryActionId}`}
                        >
                            {rec.name}
                        </Link>
                    </p>
                ))}
            </div>
        );
    }
    return <div />;
};
const trClassFormat = (row, rowIndex, isRecentlyUpdated) => {
    if (isRecentlyUpdated && row.abnormalityId === isRecentlyUpdated.id) {
        return 'recently-updated';
    }
};

const AbnormalitiesList = ({
    run,
    runId,
    showAbnormalitySelectionModal,
    onCreateAbnormalityClick,
    onCloseAbnormalitySelectionModal,
    isRecentlyUpdated,
}) => {
    if (!run) {
        return <p className="text-center">Loading abnormalities...</p>;
    }

    return (
        <Panel collapsible defaultExpanded header="Abnormalities">
            {run &&
                run.abnormalities &&
                run.abnormalities.length === 0 && <p>No abnormalities reported...</p>}
            {run &&
                run.abnormalities &&
                run.abnormalities.length > 0 && (
                    <BootstrapTable
                        data={run.abnormalities}
                        maxHeight="465px"
                        hover
                        scrollTop="Top"
                        options={{
                            defaultSortName: 'abnormalityDate',
                            defaultSortOrder: 'desc',
                        }}
                        trClassName={(a, b) => trClassFormat(a, b, isRecentlyUpdated)}
                    >
                        <TableHeaderColumn isKey dataField="abnormalityId" hidden>
                            ID
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="abnormalityId"
                            dataFormat={indexFormatter}
                            dataAlign="center"
                            width="50"
                        >
                            #
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="name" dataFormat={linkFormatter}>
                            Name
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="abnormalityType"
                            dataFormat={type => I18N.ABNORMALITIES[type]}
                        >
                            Type
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="abnormalityDate"
                            dataFormat={dateFormatter}
                            dataSort
                        >
                            Occurrence date
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="recoveryActions"
                            dataFormat={recoveryActionsFormatter}
                        >
                            Recovery action
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="abnormalityStatus"
                            dataFormat={status => I18N.ABNORMALITY_STATUS[status]}
                        >
                            Status
                        </TableHeaderColumn>
                    </BootstrapTable>
                )}

            <AuthorizedComponent
                requiredRoles={[
                    ROLES.RUN_DETAILS_LP_EDITOR,
                    ROLES.RUN_DETAILS_TME_EDITOR,
                    ROLES.ABNORMALITY_BLOWOUT_CREATOR,
                    ROLES.ABNORMALITY_DELAY_CREATOR,
                    ROLES.ABNORMALITY_MISCOLLECTION_CREATOR,
                    ROLES.ABNORMALITY_GENERIC_CREATOR,
                ]}
            >
                <Button
                    bsStyle="success"
                    style={{ marginTop: 10 }}
                    onClick={onCreateAbnormalityClick}
                >
                    Create abnormality
                </Button>
            </AuthorizedComponent>

            {showAbnormalitySelectionModal && (
                <AbnormalitySelectionModal
                    onHide={onCloseAbnormalitySelectionModal}
                    backdrop
                    runId={runId}
                    showModal={showAbnormalitySelectionModal}
                    onCloseModal={onCloseAbnormalitySelectionModal}
                />
            )}
        </Panel>
    );
};

export default AbnormalitiesList;
